import { Box } from '@aicon-dev/caas-core';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { CalendarMask } from './Calendar.Mask';
import { useCalendarDetailStore } from './store';

export const CalendarDetail = () => {
  const { visible, curItem, setVisible } = useCalendarDetailStore();
  const { t } = useTranslation('schedule');
  const period = (start?: string, end?: string) => {
    if (!start || !end) return;
    return `${dayjs(start).format('ll')} ~ ${dayjs(end).format('ll')}`;
  };

  return (
    <CalendarMask
      visible={visible}
      style={{
        width: '80vw',
        alignItems: 'normal',
        borderRadius: '4px',
      }}
      onClose={() => {
        setVisible(false);
      }}
    >
      <Box>
        {curItem?.text || curItem?.task_id ? (
          <Box display={'flex'} alignItems={'center'} position={'relative'} overflow={'hidden'}>
            <Box
              minWidth={'8px'}
              flex={1}
              position={'absolute'}
              height="100%"
              background={curItem?.color}
            ></Box>
            <Box
              pl="12px"
              py="16px"
              height={'100%'}
              width={'100%'}
              background={curItem?.color + '1a'}
            >
              {curItem.title}
            </Box>
          </Box>
        ) : (
          <Box
            p="16px"
            borderBottom={'1px solid #EEEEEE'}
            background={curItem?.color}
            color={'#FFFFFF'}
          >
            {curItem?.title}
          </Box>
        )}
        <Box p="16px">
          <Box color={'#7F8892'} mb="8px">
            {t('schedule:process_period')}
          </Box>
          <Box>{period(curItem?.startDate, curItem?.endDate)}</Box>
        </Box>

        {curItem?.tasks?.length ? (
          <>
            <Box ml="1px" width={'calc(100% - 2px)'} height={'8px'} background={'#F6F7F9'}></Box>
            <Box p="16px">
              <Box color={'#7F8892'} mb="8px">
                {t('schedule:detail_process')}
              </Box>
              {curItem?.tasks.map((task: any) => {
                return (
                  <Box key={task._id}>
                    <Box lineHeight={'22px'}>{task.text}</Box>
                    <Box color={'#7F8892'} fontSize={'14px'}>
                      {period(task.startDate, task.endDate)}
                    </Box>
                  </Box>
                );
              })}
            </Box>
          </>
        ) : null}
      </Box>
      <Box display={'flex'} alignItems={'center'} width={'100%'} height={'48px'}>
        <Box
          display={'flex'}
          width="100%"
          alignItems={'center'}
          justifyContent={'center'}
          border={'1px solid #EEEEEE'}
          height={'100%'}
          onClick={() => {
            setVisible(false);
          }}
        >
          {t('schedule:close')}
        </Box>
      </Box>
    </CalendarMask>
  );
};
